import { useCallback, useContext, useMemo, useReducer } from 'react'

import { uiActionType } from '@/Shared/domain'
import { UIContext, UIState, uiInitialState, uiReducer } from '@/Shared/ui/navigation'
import { ProtectedNavigationModalProps } from '@/Shared/ui/navigation/atoms/ProtectedNavigationModal'

export const UIProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [state, dispatch] = useReducer(uiReducer, uiInitialState)

  const openSidebar = useCallback(
    () => dispatch({ type: uiActionType.openSidebar }),
    [dispatch],
  )

  const closeSidebar = useCallback(
    () => dispatch({ type: uiActionType.closeSidebar }),
    [dispatch],
  )

  const toggleSidebar = useCallback(
    () => dispatch({ type: uiActionType.toggleSidebar }),
    [dispatch],
  )

  const openHelper = useCallback(
    () => dispatch({ type: uiActionType.openHelper }),
    [dispatch],
  )

  const closeHelper = useCallback(
    () => dispatch({ type: uiActionType.closeHelper }),
    [dispatch],
  )

  const closingHelper = useCallback(
    () => dispatch({ type: uiActionType.closingHelper }),
    [dispatch],
  )

  const registerNavigationModal = useCallback(
    (props: ProtectedNavigationModalProps) =>
      dispatch({ type: uiActionType.registerNavigationModal, props }),
    [dispatch],
  )

  const unregisterNavigationModal = useCallback(
    () => dispatch({ type: uiActionType.unregisterNavigationModal }),
    [dispatch],
  )

  const value = useMemo(
    () => ({
      ...state,
      openSidebar,
      closeSidebar,
      toggleSidebar,
      openHelper,
      closingHelper,
      closeHelper,
      registerNavigationModal,
      unregisterNavigationModal,
    }),
    [state],
  )

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>
}

export const useUI = (): UIState => useContext(UIContext)
